import React from "react";
import styled from 'styled-components';
import Slider from "react-slick";
// import imgOne from "../../img/newsEvent.jpg";

import imgOne from "../../img/stemon-top-bnr.jpg";
import imgThree from "../../img/newsEvent2.jpg";
import imgTwo from "../../img/campaign.jpg";
import imgFor from "../../img/stemon-referral.jpg";
import seminar from "../../img/seminar.jpg";
import imgFive from "../../img/rika.jpg";

const Scope =styled.div`
text-align: -webkit-center;
`
export default function SimpleSlider() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 300,
    autoplay:true,
  };
  
  const images = [
    // imgOne,imgThree,imgFor
    imgThree,imgFor
    // imgThree,imgFor
    // imgTwo,imgThree,imgFor
    // imgOne,imgFive,imgTwo,imgThree,imgFor
  ] 
  return (
    <Slider {...settings}>
      {images.map((src: string, index: number)=>
        <Scope >
          {index == 1 &&
              <img style={{width:'90%',height:'auto'}} src={src} key={`${index}`} alt="pictuer" />    
          }          
          {index !== 1 &&
            <img style={{width:'90%',height:'auto'}} src={src} key={`${index}`} alt="pictuer" />    
          }          
        </Scope>
      )}
    </Slider>
  );
}
